"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const IllustrationWithDrawing = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "illustration-with-drawing__illu--desktop" },
            react_1.default.createElement("div", { className: "login-illustration" },
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: "100%"
                    } },
                    react_1.default.createElement("span", { style: {
                            fontSize: "3.1rem",
                            fontFamily: "Fira Sans",
                            color: "rgb(16, 37, 68)",
                            fontWeight: "700",
                            letterSpacing: "0.2rem"
                        } }, "\"The road to success is always under construction.\" \uD83D\uDEA7"))))));
};
exports.default = IllustrationWithDrawing;
